@if (dataResource.hasValue()) {
  <div
    #cytoscapeContainer
    class="cytoscape-container"
    [style.background-image]="backgroundUrl() ? 'url(' + backgroundUrl() + ')' : null"
  ></div>
} @else if (dataResource.error(); as error) {
  <div class="alert alert-danger">{{ error }}</div>
}
